import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/APCO_Logo_Color_40px.png'


const _hoisted_1 = {
  class: "navbar navbar-expand-sm bg-white shadow",
  role: "navigation",
  "aria-label": "Main Navigation"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarNavAltMarkup\" aria-controls=\"navbarNavAltMarkup\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-icon\"></span></button><div class=\"collapse navbar-collapse\" id=\"navbarNavAltMarkup\"><div class=\"navbar-nav\"><a class=\"navbar-brand\" href=\"/\" aria-label=\"APCO Logo\"><img src=\"" + _imports_0 + "\" alt=\"APCO Logo\"></a></div></div>", 2)
const _hoisted_5 = { class: "nav justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link link-primary",
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "User Guide",
    href: "https://apcoeasycare.sharepoint.com/:w:/s/Progressive/EdgU1x3zmTlCskPBjh3T20oBNaxhK2dtCLCAiB2QK51idg?e=pwe3bm"
  }, " User Guide"),
  /*#__PURE__*/_createCommentVNode(" for an icon, replace \"User Guide\" with the following code "),
  /*#__PURE__*/_createCommentVNode(" <span class=\"icon icon-question-circle\" aria-hidden=\"true\" style=\"font-size: 24px;\"></span> ")
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_8 = {
  class: "nav-link dropdown-toggle",
  "data-bs-toggle": "dropdown",
  href: "#",
  role: "button",
  "aria-expanded": "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_5, [
        _hoisted_6,
        ($setup.auth0.isAuthenticated)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, _toDisplayString($setup.username), 1 /* TEXT */),
              _createElementVNode("ul", { class: "dropdown-menu" }, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: $setup.handleLogout
                  }, "Logout")
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}